






























import { Component, Prop, Vue } from 'vue-property-decorator';
import { EyeIcon, EyeOffIcon } from 'vue-feather-icons';

@Component({
  components: { EyeIcon, EyeOffIcon },
})
export default class FormInputPassword extends Vue {
  @Prop({ required: true, type: [String, Number] })
  readonly value!: string | number;

  @Prop({ required: false, type: Boolean, default: false })
  readonly required!: boolean;

  @Prop({ required: false, type: Array })
  errors!: string[];

  isPasswordVisible = false;
}
